import { createEntityCollectionStore } from '@core/ngrx-legacy';
import type { Stage } from '@core/stages-types';

const { actions, reducer, namespace, selectors } = createEntityCollectionStore<Stage>()(
  'offer-stages',
  {
    customActions: adapter => ({
      references: (state, payload: { data: Stage[] }) =>
        adapter.updateOrCreateMany(state, payload.data),
    }),
  },
);

const StageActions = <Pick<typeof actions, 'references'>>actions;

const StageSelectors = {
  ...selectors,
};

export { StageActions, StageSelectors, reducer as StageReducer, namespace as StageNamespace };
